export default __webpack_public_path__ + "static/media/arrow-left-right.3dae967e.svg";